import { getViemClients, } from "@bracket/contractor-next";
import type { Config } from "@wagmi/core";

import {
	getContractWithABI,
	type ValidChainId,
} from "@bracket/chainography";

export declare type getBracketRateProps = {
	chainId?: ValidChainId;
	config?: Config;
	bigint?: boolean;
};


/**
 * Get the Brkt->ETH rate.
 * @param {ValidChainId} chainId the chain, supports only chain 1 and will error if not 1.
 * @param {Config} config wagmi/viem configuration to use instead of the default viem client.
 * @returns {Promise<bigint>} the rate to the power of 18
 */
export const getBracketRate = async ({
	chainId = 1,
	config,
	bigint = false,
}: getBracketRateProps = {}): Promise<number|bigint> => {

	try {

		if (chainId !== 1) throw new Error("getBracketRate supports only chain 1");

		const [vclient, _] = await getViemClients({ chainId, config, });
		const [address, abi] = getContractWithABI("BrktETH");
		const result = await vclient.readContract({
			address,
			abi,
			functionName: "getBracketRate",
			args: []
		});

		if(typeof result === "bigint") {

			if(bigint) {
				return result;
			}
			return Number(result) / 1e18;
		}

		throw new Error("contract did not return the expected value as a bigint");
	} catch (err) {

		throw new Error(`@bracket/chainography/brktETH:getBracketRate failed - ${err.message}`);
	}
};
